
<form [formGroup]="resetForm" (ngSubmit)="onResetSubmit()">

  <div class="card">
    <div class="card-header font-weight-bold lead bg-success text-white">
      Set Password
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label for="password">New Password</label>
            <input id="password" type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': resetSubmitted && f2.password.errors }" autocomplete="new-password" />
            <small class="form-text text-muted">Use at least 8 characters, including an uppercase letter, a lowercase letter, a number, and a symbol.</small>
            <div *ngIf="resetSubmitted && f2.password.errors" class="invalid-feedback">
              <div *ngIf="f2.password.errors.required">New Password is required</div>
              <div *ngIf="f2.password.errors.passwordPolicy">New Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number, and a symbol.</div>
              <div *ngIf="f2.password.errors.maxlength">New Password must be 100 characters or fewer.</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <input type="password" class="form-control" id="confirmPassword" formControlName="confirmPassword"
                   [ngClass]="{ 'is-invalid': resetSubmitted && f2.confirmPassword.errors }" autocomplete="new-password" />
            <div *ngIf="resetSubmitted && f2.confirmPassword.errors" class="invalid-feedback">
              <div *ngIf="f2.confirmPassword.errors.required">Confirm Password is required</div>
              <div *ngIf="f2.confirmPassword.errors.confirmedValidator">New Password and Confirm Password must match.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12 form-group">
          <button type="submit" [disabled]="resetLoading" class="btn btn-primary btn-block btn-lg" [class.button-loading]="resetLoading">Change</button>
        </div>
      </div>
    </div>
  </div>
</form>
